import './index.css';
import 'antd/dist/antd.css';
import 'jsoneditor/dist/jsoneditor.min.css';

import * as serviceWorker from './serviceWorker';

import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import setupAxiosInterceptors from './global/interceptors';
import myStore from './store/createStore';

const store = myStore();

setupAxiosInterceptors(store);
ReactDOM.render(
	<Provider store={store}>
		<Router>
			<App />
		</Router>
	</Provider>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
